import React from 'react';

const WithHeader = InnerComponent => {
  return props => {
    const { headerText, ...otherProps } = props;
    const component = <InnerComponent {...otherProps} />;
    return !!headerText ? (
      <React.Fragment>
        <div className="control-header-text">{headerText}</div>
        {component}
      </React.Fragment>
    ) : (
      component
    );
  };
};

export default WithHeader;
